import Grid from "@mui/material/Grid"
import DatePicker from "component/datePicker/datePicker"

interface ContractDatesProps {
    contractStartDate: string
    contractEndDate: string
    onStartDateChange: (date: string) => void
    onEndDateChange: (date: string) => void
    contractDateErrors: string[]
    showValidationErrors: boolean
}

const ContractDates = ({
    contractStartDate,
    contractEndDate,
    onStartDateChange,
    onEndDateChange,
    contractDateErrors,
    showValidationErrors,
}: ContractDatesProps) => {
    return (
        <Grid container spacing={2} style={{ width: "100%", marginBottom: "20px" }}>
            <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                <DatePicker
                    label="From Date"
                    placeholder="Select Contract Start Date"
                    value={contractStartDate}
                    onChange={onStartDateChange}
                    required={true}
                    error={
                        showValidationErrors
                            ? !contractStartDate
                                ? "Required"
                                : Array.isArray(contractDateErrors) && contractDateErrors.length > 0
                                    ? contractDateErrors.filter((e) => typeof e === "string").join(", ")
                                    : undefined
                            : undefined
                    }
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                <DatePicker
                    label="To Date"
                    placeholder="Select Contract End Date"
                    value={contractEndDate}
                    onChange={onEndDateChange}
                    minDate={contractStartDate || undefined}
                    required={true}
                    error={
                        showValidationErrors
                            ? !contractEndDate
                                ? "Required"
                                : Array.isArray(contractDateErrors) && contractDateErrors.length > 0
                                    ? contractDateErrors.filter((e) => typeof e === "string").join(", ")
                                    : undefined
                            : undefined
                    }
                />
            </Grid>
        </Grid>
    )
}

export default ContractDates
